import { connect } from 'react-redux';
import AggregateRow from '../components/aggregate_row';
import { toggleMemberFavorite } from '../actions/member_search_index';
import { fetchDetails, removeDetails } from '../actions/details_index';
import { selectIsManagerSite, selectDisplayedFlags, selectStateFlagUrls, selectVisibleColumns } from '../selectors'

const mapStateToProps = (state, ownProps) => {
  const eventId = String(ownProps.eventId);
  const eventState = state.event?.[eventId];
  const memberId = ownProps.agg?.memberIds?.[0]

  return {
    rounds: eventState?.data?.rounds ?? {},
    columns: selectVisibleColumns(state, eventId),
    // A boolean, not the array: connect shallow-compares, so starring one
    // player re-renders that row instead of every row in the table.
    isFavorite: !!memberId && (eventState?.favorites ?? []).includes(memberId),
    details: state.details[eventId] ?? {},
    colorScores: state.leaderboardV2.colorScores,
    displayedFlags: selectDisplayedFlags(state, eventId),
    stateFlagUrls: selectStateFlagUrls(state),
    isManagerSite: selectIsManagerSite(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  // The row star favorites the member in every event they played (and
  // removes them everywhere on unstar), same as the member-search star.
  // The clicked eventId makes the add optimistic: that event's star and
  // favorites table update synchronously while the played-events fan-out
  // resolves the rest in the background.
  toggleFavorite: (eventId, memberId) => dispatch(toggleMemberFavorite(memberId, eventId)),
  fetchDetails: (eventId, aggId, detailsKey) => dispatch(fetchDetails(eventId, aggId, detailsKey)),
  removeDetails: (eventId, detailsKey) => dispatch(removeDetails(eventId, detailsKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AggregateRow);
